module.exports = __webpack_public_path__ + "img/borrower_benefit_uniqueplan_mobile.a9c7251f.jpg";